import { render } from "./replenish.vue?vue&type=template&id=0b88d4fc&scoped=true"
import script from "./replenish.vue?vue&type=script&lang=js"
export * from "./replenish.vue?vue&type=script&lang=js"

import "./replenish.vue?vue&type=style&index=0&id=0b88d4fc&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b88d4fc"]])

export default __exports__